import { vaults } from '@/features/vaults/vaults';
import { isTestNetwork } from '@/core/config';
import { isProductionApp } from '@/core/helpers/isProductionApp';
import { Network } from '@/shared/types/Network';

export function getVaults(networks: Network[]) {
  return vaults.filter(vault => {
    if (isProductionApp() && isTestNetwork(vault.network)) {
      return false;
    }

    return networks.includes(vault.network);
  });
}
